import { useNavigate } from 'react-router-dom';

export const useAppNavigate = () => useNavigate();
